export const isValidHTML = htmlStr => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(htmlStr, 'text/xml')
  if (doc.documentElement.querySelector('parsererror')) {
    return false
  } else {
    return true
  }
}
